import apiClient from './client';

export interface GitHubConnectionStatus {
  connected: boolean;
  github_username: string | null;
}

export interface GitHubRepo {
  full_name: string;
  name: string;
  private: boolean;
  default_branch: string;
  description: string | null;
}

export async function getGitHubStatus(): Promise<GitHubConnectionStatus> {
  const resp = await apiClient.get('/api/v1/github/status');
  return resp.data;
}

export async function exchangeGitHubCode(code: string): Promise<GitHubConnectionStatus> {
  const resp = await apiClient.post('/api/v1/github/callback', { code });
  return resp.data;
}

export async function disconnectGitHub(): Promise<void> {
  await apiClient.delete('/api/v1/github/disconnect');
}

export async function fetchGitHubRepos(): Promise<GitHubRepo[]> {
  const resp = await apiClient.get('/api/v1/github/repos');
  return resp.data.repos;
}
